var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGearSmall = function SvgGearSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.84 3.68c.295-1.215 2.025-1.215 2.32 0a1.194 1.194 0 0 0 1.78.739c1.07-.651 2.293.572 1.642 1.64a1.194 1.194 0 0 0 .737 1.781c1.216.295 1.216 2.024 0 2.32a1.194 1.194 0 0 0-.738 1.78c.65 1.069-.572 2.292-1.64 1.642a1.193 1.193 0 0 0-1.781.737c-.295 1.215-2.025 1.215-2.32 0a1.194 1.194 0 0 0-1.78-.738c-1.07.65-2.292-.572-1.642-1.641a1.193 1.193 0 0 0-.737-1.78c-1.216-.296-1.216-2.025 0-2.32a1.193 1.193 0 0 0 .738-1.781c-.65-1.068.572-2.292 1.64-1.64.693.42 1.59.048 1.781-.738Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.923 9a2.077 2.077 0 1 0 4.154 0 2.077 2.077 0 0 0-4.154 0Z"
  }))));
};
export default SvgGearSmall;